var Layout = require('./lib/Layout.js');
var Fixed = require('./lib/Fixed.js');
var Flex = require('./lib/Flex.js');

module.exports = {
    Layout: Layout,
    Fixed: Fixed,
    Flex: Flex
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-layout-pane/index.js
// module id = 1048
// module chunks = 0